/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { fromJS } from 'immutable';
import isEqual from 'lodash/isEqual';
import xorWith from 'lodash/xorWith';

import { SET_LIST_SELECTION, TOGGLE_LIST_SELECTION } from './constants';
/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */

const listSelectionState = fromJS({
  listSelections: []
});

function listSelectionReducer(state = listSelectionState, action) {
  const getCurrentListSelections = state.get('listSelections').toJS();

  switch (action.type) {
    case SET_LIST_SELECTION:
      return state.set('listSelections', fromJS(action.value));
    case TOGGLE_LIST_SELECTION:
      const setNew = xorWith(getCurrentListSelections, action.value, isEqual);
      return state.set('listSelections', fromJS(setNew));
    default:
      return state;
  }
}
/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default listSelectionReducer;
